import { connect } from "react-redux";
import * as actions from "./actions";

function mapStateToProps(state) {
  return {
    restRepayments: state.restRepayments,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadRestRepayments: () => {
      dispatch(actions.get_loans_for_rest_repayment());
    },

    restRepayLoan: (creditId, callback) => {
      dispatch(actions.rest_repay_loan(creditId, callback));
    },
  };
}

export const restRepaymentConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
